<template>
  <div class="select-shop">

    <el-form label-position="top" ref="form" :model="form" label-width="72px">
      <div>
        <h3 style="margin-bottom: 20px;">选择商家</h3>
        <el-row :gutter="60" type="flex">
          <el-col :xs="24" :sm="12" :md="12" :lg="12">
            <div class="shop-list">
              <search-ipt placeholder="搜索商家" :object="filters" object-key="shopName"></search-ipt>
              <ul>
                <li :class="{'selected': shop.id == selectedShop.id}" @click="selectedShop = shop" v-for="shop in filterBy(shops, filters['shopName'], 'name')">{{shop.name}}</li>
              </ul>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12">
            <div class="selected-shop">
              <div v-if="!selectedShop.id" class="empty">
                <div>
                  <h3>您还未选择商家</h3>
                  <p>从左侧的商家列表选择</p>
                </div>
              </div>
              <div class="selected-shop-content" v-if="selectedShop.id">
                <div v-if="selectedShop.logo" class="img-container">
                  <img :src="selectedShop.logo" width="100%">
                </div>
                <p class="name">{{selectedShop.name}}</p>
                <p>{{selectedShop.country}}</p>
                <p>{{selectedShop.website}}</p>
                <p>{{selectedShop.introduce}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <p class="add-shop">找不到您要的商家？<AddShop v-on:success="getGroupBussinessList"><a>去添加</a></AddShop></p>
      <el-row :gutter="60">
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-form-item label="选择货币">
            <el-select class="height-50" @change="changeCurrency" v-model="currentCurrency" placeholder="请选择货币" style="width: 100%;">
              <el-option
                v-for="item in CURRENCIES"
                :key="item.value"
                :label="item.name+'('+item.symbol+item.value+')'"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-form-item label="收货地区">
            <el-select class="height-50" v-model="form.area" placeholder="请选择国家" style="width: 100%;">
              <el-option
                v-for="item in COUNTRIES"
                :key="item.value"
                :label="item.name+'('+item.value+')'"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="text-center btn-container">
        <el-button :disabled="disabled" class="btn-320" type="info" @click="next()">确定</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SearchIpt from '../../components/SearchIpt'
import AddShop from './components/AddShop'
import api from '../../services/api'
import { FILE_HOST, COUNTRIES, CURRENCIES } from '../../services/constant'

export default {
  name: 'SelectBuyer',
  components: {
    searchIpt: SearchIpt,
    AddShop: AddShop
  },
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  created: function () {
    this.$store.commit('clearTaskInfo')
    this.$router.push({ path: 'cart' })
    // this.getGroupBussinessList()
  },
  data () {
    return {
      currentCurrency: null,
      disabled: true,
      filters: {
        shopName: null
      },
      form: {
        currency: null,
        area: null
      },
      shops: [],
      selectedShop: {
        id: null
      },
      FILE_HOST: FILE_HOST,
      COUNTRIES: COUNTRIES,
      CURRENCIES: CURRENCIES
    }
  },
  methods: {
    changeCurrency (currency) {
      this.form.currency = currency.value
      this.form.currency_symbol = currency.symbol
    },
    getGroupBussinessList: function () {
      api.getGroupBussinessList(this, {setLs: true})
        .then(res => {
          let result = res.body.result || []
          this.shops = result
        })
    },
    next () {
      if (!this.selectedShop) {
        this.$message.error('请选择商家')
      } else if (!this.form.currency) {
        this.$message.error('请选择货币')
      } else if (!this.form.area) {
        this.$message.error('请选择收货地区')
      } else {
        this.form.business_id = this.selectedShop.id
        this.form.business_name = this.selectedShop.name
        this.form.business_website = this.selectedShop.website
        this.$store.commit('clearTaskInfo')
        this.$store.commit('updateTaskInfo', this.form)
        this.$router.push({ path: 'products' })
      }
    },
    checkSubmitValid () {
      if (this.selectedShop.id && this.form.currency && this.form.area) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  },
  watch: {
    selectedShop: function () {
      this.checkSubmitValid()
    },
    form: {
      handler: function () {
        this.checkSubmitValid()
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.add-shop {
  font-size:14px;
  color:rgba(102,102,102,1);
  line-height:20px;
  margin: 20px 0 30px;
}
.btn-container {
  margin-top: 100px;
  margin-bottom: 30px;
}
.shop-list,
.selected-shop {
  border: 1px solid #DEE2EC;
  height: 100%;
}
.shop-list {
  border-top: none;
  border-left: none;

  ul {
    max-height: 410px;
    overflow-y: auto;
  }

  li {
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:20px;
    margin: 10px 0;
    cursor: pointer;

    &.selected {
      color: #333;
    }
  }
}
.selected-shop {
  padding: 30px;
  max-height: 450px;

  .selected-shop-content {
    img {
      max-height: 109px;
    }
    .img-container {
      height: 109px;
      text-align: center;
      border: 1px solid #DEE2EC;
      overflow: hidden;
      margin-bottom: 30px;
    }

    p {
      color: #666;
      margin-bottom: 20px;

      &.name {
        font-size:18px;
        color: #333;
        line-height:25px;
      }
    }
  }

  .empty {
    height: 100%;
    text-align: center;
    -webkit-display:flex;
    display:flex;
    -webkit-align-items:center;
    align-items:center;
    -webkit-justify-content:center;
    justify-content:center;

    h3 {
      font-size:18px;
      color:rgba(51,51,51,1);
      line-height:25px;
      margin-bottom: 10px;
      width: 100%;
    }

    p {
      height:18px;
      font-size:13px;
      color:rgba(102,102,102,1);
      line-height:18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/SelectShop.vue